import {
  type GenerateStyle,
  genComponentStyleHook,
  type FullToken,
} from "antd/es/theme/internal";
import { spinPrefixCls } from "@/base/components/spin/Spin.component";
import { THEME_PREFIX, ICON_PREFIX } from "@/base/constant";

const genStyle: GenerateStyle<FullToken<"Spin">> = ({
  indicatorSize,
  indicatorSizeSm,
  indicatorSizeLg,
}: any) => ({
  [`.${THEME_PREFIX}`]: {
    [`&.${spinPrefixCls}`]: {
      [`&.${spinPrefixCls}-lg .${ICON_PREFIX}`]: {
        fontSize: indicatorSizeLg,
      },
      [`&.${spinPrefixCls}-sm .${ICON_PREFIX}`]: {
        fontSize: indicatorSizeSm,
      },
      [`.${ICON_PREFIX}`]: {
        fontSize: indicatorSize,
      },
    },
  },
});

export const useSpinStyle = genComponentStyleHook(["Spin", "cso"], (token) => {
  return [genStyle(token)];
});
